export default "__VITE_ASSET__cc15da1b__"